module.exports = __webpack_public_path__ + "img/10.94cd6f2f.png";